import { render } from "./GamificationBadge.vue?vue&type=template&id=b679ca90&ts=true"
import script from "./GamificationBadge.vue?vue&type=script&lang=ts"
export * from "./GamificationBadge.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__